import { Controller } from "@hotwired/stimulus"
import { parseCleaveInput, formatCurrency } from "../helpers/format-helper"
import { styleInputValidation, resetInputStyling } from "../helpers/red-bg-input-validation"

export default class extends Controller {
  static targets = ["slider", "valueDisplay", "valueInput", "minLabel", "maxLabel", "pricePerSqm"]
  static values = {
    min: Number,
    max: Number,
    default: Number,
    squareMeters: Number,
  }

  connect() {
    this.updateSliderBackground()
    this.updateValueDisplay()
    
    // Check initial styling
    if (this.hasValueInputTarget) {
      const numericValue = parseCleaveInput(this.valueInputTarget.value)
      if (!isNaN(numericValue)) {
        styleInputValidation(this.valueInputTarget, numericValue, this.minValue, this.maxValue)
      }
    }
  }

  sliderChanged() {
    this.updateSliderBackground()
    this.updateValueDisplay()
  }

  updateSliderBackground() {
    const slider = this.sliderTarget
    const min = parseFloat(slider.min)
    const max = parseFloat(slider.max)
    const value = parseFloat(slider.value)
    const percentage = ((value - min) / (max - min)) * 100

    slider.style.background = `linear-gradient(to right, var(--slider-active-start) 0%, var(--slider-active-end) ${percentage}%, var(--slider-inactive) ${percentage}%, var(--slider-inactive) 100%)`
  }

  updateValueDisplay() {
    const value = parseFloat(this.sliderTarget.value)
    const formattedValue = formatCurrency(value)

    if (this.hasValueInputTarget) {
      this.valueInputTarget.value = formattedValue
    }

    if (this.hasPricePerSqmTarget && this.hasSquareMetersValue && this.squareMetersValue > 0) {
      const pricePerSqm = Math.round(value / this.squareMetersValue)
      this.pricePerSqmTarget.textContent = formatCurrency(pricePerSqm)
    }
  }

  updateSliderFromInput() {
    if (!this.hasValueInputTarget || !this.hasSliderTarget) return
    
    const inputValue = this.valueInputTarget.value
    const numericValue = parseCleaveInput(inputValue)
    
    if (!isNaN(numericValue)) {
      this.sliderTarget.value = numericValue
      this.updateSliderBackground()
      
      styleInputValidation(this.valueInputTarget, numericValue, this.minValue, this.maxValue)
      
      if (numericValue >= this.minValue && numericValue <= this.maxValue) {
        this.sliderTarget.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }
  }

  validateInputRange() {
    if (!this.hasValueInputTarget || !this.hasSliderTarget) return
    
    const inputValue = this.valueInputTarget.value
    const numericValue = parseCleaveInput(inputValue)
    
    if (isNaN(numericValue)) {
      this.updateValueDisplay()
      resetInputStyling(this.valueInputTarget)
      this.sliderTarget.dispatchEvent(new Event('input', { bubbles: true }))
      return
    }
    
    if (numericValue < this.minValue || numericValue > this.maxValue) {
      this.updateValueDisplay()
      resetInputStyling(this.valueInputTarget)
      this.sliderTarget.dispatchEvent(new Event('input', { bubbles: true }))
    } else {
      this.sliderTarget.value = numericValue
      this.updateSliderBackground()
      resetInputStyling(this.valueInputTarget)
      this.sliderTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
}